import { useIdentity } from 'base/identity-resolver';
import Decorator from '@evertrue/client-decorator';

const useDynamicFields = (contact) => {
  const { user } = useIdentity();

  const name = Decorator.Contacts.getFullName(contact);
  const { email = {}, phone = {} } = Decorator.Profile.getPrimaryContactInfo(contact);
  const [name_first, name_last] = name.split(' ');

  // TODO: Restore theses with updated ticket and research on relability
  // const lastGiftAmount = contact?.giving?.last_gift_amount?.value || '';
  // const lastGiftDesignation = contact?.giving?.last_gift_label?.value || '';
  // const lastGiftDate = contact?.giving?.last_gift_date?.value || '';
  // const largestGiftAmount = contact?.giving?.largest_gift_amount?.value || '';
  // const largestGiftDesignation = contact?.giving?.largest_gift_label?.value || '';
  // const largestGiftDate = contact?.giving?.largest_gift_date?.value || '';

  const allFields = [
    {
      key: '{{prefix}}',
      name: 'Prefix',
      value: contact?.contact_attributes?.name_prefix || contact?.properties?.name_prefix?.value || '',
    },
    {
      key: '{{name_first}}',
      name: 'First Name',
      value: name_first || contact?.contact_attributes?.name_first || '',
    },
    {
      key: '{{name_last}}',
      name: 'Last Name',
      value: name_last || contact?.contact_attributes?.name_last || '',
    },
    {
      key: '{{name_nick}}',
      name: 'Nickname',
      value: contact?.contact_attributes?.name_nick || contact?.properties?.name_nick?.value || '',
    },
    {
      key: '{{primary_phone}}',
      name: 'Primary Phone',
      value: phone?.phone || contact?.phones?.filter((phone) => phone.primary)?.[0]?.phone || '',
    },
    {
      key: '{{primary_email}}',
      name: 'Primary Email',
      value: email?.email || contact?.emails?.filter((email) => email.primary)?.[0]?.email || '',
    },
    {
      key: '{{user_name}}',
      name: 'Your Name',
      value: user?.name,
    },
    // TODO: Restore theses with updated ticket and research on relability
    // {
    //   key: '{{last_gift_amount}}',
    //   name: 'Last Gift Amount',
    //   value: lastGiftAmount ? `$${lastGiftAmount}` : '',
    // },
    // {
    //   key: '{{last_gift_designation}}',
    //   name: 'Last Gift Designation',
    //   value: lastGiftDesignation,
    // },
    // {
    //   key: '{{last_gift_date}}',
    //   name: 'Last Gift Date',
    //   value: lastGiftDate,
    // },
    // {
    //   key: '{{largest_gift_amount}}',
    //   name: 'Largest Gift Amount',
    //   value: largestGiftAmount ? `$${largestGiftAmount}` : '',
    // },
    // {
    //   key: '{{largest_gift_designation}}',
    //   name: 'Largest Gift Designation',
    //   value: largestGiftDesignation,
    // },
    // {
    //   key: '{{largest_gift_date}}',
    //   name: 'Largest Gift Date',
    //   value: largestGiftDate,
    // },
  ];

  const dynamicFieldPlaceholders = allFields.reduce((acc, { name, key }) => {
    acc[name] = key;
    return acc;
  }, {});

  // Only include fields with actual values
  // For outreach emails (no contact), only show "Your Name"
  const dynamicFields = allFields.reduce((acc, field) => {
    if (!contact && field.name !== 'Your Name') {
      return acc; // Skip all fields except "Your Name" when there's no contact
    }
    if (field.value) {
      acc[field.name] = field.value; // Only include fields that have values
    }
    return acc;
  }, {});

  const getDynamicFieldValue = (key) => {
    const templateKey = `{{${key}}}`;
    return allFields.find((field) => field.key === templateKey)?.value;
  };

  const parseBodyForDynamicFields = (body) => {
    return body.replace(/\{\{([^}]+)\}\}/g, (match, p1) => {
      const value = getDynamicFieldValue(p1);
      return value || match;
    });
  };

  const bodyHasMissingFields = (body) => {
    return /\{\{[^}]+\}\}/.test(body);
  };

  const getUnsupportedFields = (body) => {
    // Extract all properly formed dynamic fields from the body (those with {{...}})
    const matches = body.match(/\{\{([^{}]+)\}\}/g) || [];

    // Return array of fields in body that don't exist in our allFields
    return matches.filter((bodyField) => {
      return !allFields.some((field) => field.key === bodyField);
    });
  };

  const getEmptyFields = (body) => {
    // Extract all properly formed dynamic fields from the body
    const matches = body.match(/\{\{([^{}]+)\}\}/g) || [];

    // Return array of fields in body that exist in allFields but have no value
    return matches.filter((bodyField) => {
      const field = allFields.find((f) => f.key === bodyField);
      return field && !field.value;
    });
  };

  return {
    dynamicFields,
    parseBodyForDynamicFields,
    bodyHasMissingFields,
    dynamicFieldPlaceholders,
    getUnsupportedFields,
    getEmptyFields,
  };
};

export default useDynamicFields;
